import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_ROLE_AUTHORITY_LIST',
    method: 'GET',
    manual: true,
  });
  useEffect(() => {
    if (params) {
      let url = `/api/system/rolesauthority?role_id=${params}`;
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], exec];
});
